import { Outlet } from "react-router-dom";
import RouterNavigatorBinder from "./routerNavigatorBinder";

const RootLayout = () => (
  <>
    <RouterNavigatorBinder />
    <Outlet />
  </>
);
export default RootLayout;
